import { OrderVerified } from 'services/order/order.type';

export const orderMock = {
    orderId: 135916,
    brandId: 10,
    restaurantId: 11,
    channelId: 2,
    menuId: 1796,
    promocodeId: null,
    customerId: null,
    userId: null,
    userName: null,
    addressRawData: null,
    addressId: null,
    cardId: null,
    paymentMean: null,
    ticketNumber: '10_11_2022-09-08_0',
    offlineTicketNumber: null,
    comment: null,
    currency: 'EUR',
    locale: 'fr',
    expectedDate: '2022-09-08T23:00:00.000Z',
    expectedDateEnd: null,
    mainStatus: 8,
    driveStatus: null,
    deliveryStatus: null,
    paymentStatus: null,
    consommationMode: 2,
    forceOnlinePayment: true,
    deliveryFee: null,
    minimumAmountDelivery: null,
    minimumAmountForFreeDelivery: null,
    ttcTotalPrice: 1000,
    vatTotalPrice: 91,
    ttcUpselling: null,
    ttcEntranceFee: 0,
    ttcServiceFee: 0,
    ttcDeliveryFee: 0,
    ttcPromocodeReduction: 0,
    ttcGrantReduction: 0,
    takeAwayReduction: 0,
    ttcTakeAwayReduction: 0,
    ttcRoyaltyReduction: 0,
    ttcLuncheonEligibleAmount: 1000,
    emittedRoyalties: 800,
    ewalletBalanceBeforeOrder: null,
    ewalletBalanceAfterOrder: null,
    entranceFeeRawData: null,
    grantRawData: null,
    pricingRuleRawData: null,
    cartRawData:
        '{"enrichedCart":[{"productId":869209,"quantity":10,"steps":[],"name":"Cheddar","originalUnitPrice":100,"price":1000,"unitPrice":100,"vat":1000,"externalReferences":{},"tags":{"4933":{"tagId":4933,"name":"Extra Cheddar"}},"servingCount":0,"isEligibleLuncheon":true,"isProducible":false}],"version":"enriched-cart-1"}',
    orderRecapRawData:
        '{"currency":"EUR","products":[{"label":"Cheddar","id":869209,"taxRate":1000,"totalPrice":{"totalInclTax":1000,"totalExclTax":909,"totalTax":91,"totalInclTaxWithDiscount":1000,"totalExclTaxWithDiscount":909,"totalTaxWithDiscount":91,"totalInclTaxWithRemise":1000,"totalExclTaxWithRemise":909,"totalTaxWithRemise":91},"unitPrice":{"totalInclTax":100,"totalExclTax":91,"totalTax":9,"totalInclTaxWithDiscount":100,"totalExclTaxWithDiscount":91,"totalTaxWithDiscount":9,"totalInclTaxWithRemise":100,"totalExclTaxWithRemise":91,"totalTaxWithRemise":9},"depth":0,"quantity":10,"additionalData":{"amountWithoutUpsell":"0"},"purchasePrice":null}],"fees":[],"discounts":[],"taxRatesBreakdown":[{"taxRate":1000,"totalPrice":{"totalInclTax":1000,"totalExclTax":909,"totalTax":91,"totalInclTaxWithDiscount":1000,"totalExclTaxWithDiscount":909,"totalTaxWithDiscount":91,"totalInclTaxWithRemise":1000,"totalExclTaxWithRemise":909,"totalTaxWithRemise":91}}],"totalPrice":{"totalInclTax":1000,"totalExclTax":909,"totalTax":91,"totalInclTaxWithDiscount":1000,"totalExclTaxWithDiscount":909,"totalTaxWithDiscount":91,"totalInclTaxWithRemise":1000,"totalExclTaxWithRemise":909,"totalTaxWithRemise":91},"totalLuncheonEligibleAmount":1000,"globalDiscount":{"discountRate":0,"promocode":null},"entranceFeeAmount":0,"grantAmount":0,"turnover":1000,"turnoverWithTaxExcluded":909,"turnoverTotalTax":91,"offTurnover":0}',
    deliveryType: null,
    servingCount: 1,
    cancellationReason: null,
    cancellationReasonDescription: null,
    externalPosOrderId: null,
    ttcOnlinePaymentDiscount: 0,
    onlinePaymentDiscount: 0,
    tableName: null,
    requestIdempotencyKey: '833d72e6-a9e9-4447-8137-07181b0f3fae',
    areaUuid: null,
    metadata: null,
    created_at: '2022-09-07T19:37:21.000Z',
    updated_at: '2022-09-07T19:37:21.000Z',
    orderPayments: [],
    customer: null,
    restaurant: {
        restaurantId: 11,
        name: 'Resto Produit Innovorder',
        delayTakeAway: 20,
        phoneIndicator: null,
        contactPhone: '0442090904',
        contactName: 'bob',
        contactEmail: 'no-reply@innovorder.fr',
        brandId: 10,
        addressId: 480,
        locale: 'fr',
        kitchenDisplayId: 2,
        currency: 'EUR',
        created_at: '2017-01-31T16:28:02.000Z',
        updated_at: '2022-03-25T15:39:34.000Z',
        is_enabled: true,
        legalId: 17,
        ewalletMinimumForScanTray: 0,
        moduleStripeId: 55,
        modulePaygreenId: 10,
        moduleSplioId: 30,
        moduleApetizPlusId: 1,
        externalId: 'restaurantEatNDrinkkCDPF2',
        moduleNeptingId: 3,
        lastShiftClosureHour: null,
        canOrderAsAnonymous: true,
        address: {
            addressId: 480,
            lat: 48.8689168,
            lng: 2.3527634,
            timeZoneId: 'Europe/Paris',
            locality: 'Paris',
            route: 'Rue Blondel',
            postalCode: '75002',
            streetNumber: '30',
            administrativeAreaLevel1: 'Île-de-France',
            administrativeAreaLevel2: 'Département de Paris',
            country: 'France',
            googlePlaceId: 'ChIJ3e6Ykgdu5kcRJXtvh-3JyLU',
            providerId: 'ChIJkzIxGRFu5kcRliBS_bQYIts',
            phone: null,
            additionalInfo: null,
            digiCode: null,
            apartmentNumber: null,
            iconIdentifier: null,
            customerId: null,
            name: '30 Rue Blondel, 75002 Paris, France',
            created_at: '2017-01-31T16:28:02.000Z',
            updated_at: '2020-11-14T06:14:20.000Z',
            deleted_at: null,
        },
    },
    card: null,
    address: null,
    user: null,
    promocode: null,
    stuartJob: [],
    requiredAction: null,
} as unknown as OrderVerified;
